import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { getToken } from "@/lib/auth";

const LiveCtx = createContext({ data: null, connected: false });

export function LiveProvider({ children }) {
  const [data, setData] = useState(null);
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);

  useEffect(() => {
    let stop = false;
    let retry;
    const base = process.env.REACT_APP_BACKEND_URL || "";
    const token = getToken();
    const url =
      base.replace(/^http/, "ws") +
      "/api/ws/live" +
      (token ? `?token=${encodeURIComponent(token)}` : "");

    const connect = () => {
      if (stop) return;
      let ws;
      try {
        ws = new WebSocket(url);
      } catch (e) {
        retry = setTimeout(connect, 4000);
        return;
      }
      wsRef.current = ws;
      ws.onopen = () => setConnected(true);
      ws.onmessage = (e) => {
        try { setData(JSON.parse(e.data)); } catch (_) {}
      };
      ws.onclose = () => {
        setConnected(false);
        if (!stop) retry = setTimeout(connect, 4000);
      };
      ws.onerror = () => { try { ws.close(); } catch (_) {} };
    };
    connect();

    return () => {
      stop = true;
      clearTimeout(retry);
      if (wsRef.current) { try { wsRef.current.close(); } catch (_) {} }
    };
  }, []);

  return <LiveCtx.Provider value={{ data, connected }}>{children}</LiveCtx.Provider>;
}

export const useLive = () => useContext(LiveCtx);
